<div class="loading-overlay">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
